import { LearnerInfo, Maybe, TeamRole } from '../../../../types';

export enum SORT_KEYS {
  name = 'name',
  role = 'teamRole',
  lastLogin = 'last_login',
}

export type sortStateType = {
  key: string;
  state: number;
} | null;

export const USER_ROLES_NAMES = {
  owner: 'ownerRole',
  manager: 'managerRole',
  learner: 'memberRole',
};

export type TeamLearnerInfo = LearnerInfo & { teamRole?: Maybe<TeamRole> };
